export default {
  'profilecredit.profilecreditreport': 'تقرير تحويل حساب الائتمان',
  'profilecredit.creditstatus': 'حالة الائتمان',
  'profilecredit.credittotalamount': 'إجمالي مبلغ الائتمان النشط',
  'profilecredit.creditremainamount': 'إجمالي مبلغ الائتمان المتبقي',
  'profilecredit.profilecreditreport': 'تقرير الائتمان المخصص',
  'profilecredit.creditamount': 'مبلغ الائتمان',
  'profilecredit.remaincreditamount': 'مبلغ الائتمان المتبقي',
  'profilecredit.assigndate': 'تاريخ التخصيص',
  'profilecredit.duration': 'المدة (يوم)',
  'profilecredit.active': 'نشط',
  'profilecredit.expired': 'منتهي الصلاحية',
  'profilecredit.sum': 'مجموع',
  'profilecredit.expensesamount': 'المبلغ المصروف',
  'profilecredit.nocredit': 'لا توجد ائتمانات',
  'profilecredit.assigncredit': 'تخصيص الائتمان',
  'profilecredit.creditamountceiling': 'سقف مبلغ الائتمان',
  'profilecredit.deletecredit': 'حذف الائتمان',
  'profilecredit.deleteconfirmation': 'هل أنت متأكد من حذف هذا الائتمان؟',
  'profilecredit.fullname': 'الاسم الكامل',
  'profilecredit.expensesreport': 'تقرير المصروفات',
  'profilecredit.credit': 'ائتمان',
  'profilecredit.mycreditmanagement': 'إدارة ائتماناتي',
  'profilecredit.creditmanagement': 'إدارة الائتمانات',
  'profilecredit.employeecreditmanagement': 'إدارة ائتمانات الموظفين',
  'profilecredit.creditadd': 'تمت إضافة الائتمان بنجاح',
  'profilecredit.creditadderror': 'هناك بالفعل تخصيص نشط لهذا الملف الشخصي',
  'profilecredit.noteligibleprofile': 'هذا الملف الشخصي غير مؤهل للتخصيص',
  'profilecredit.downloadexcel': 'تحميل ملف Excel',
  'profilecredit.fromdate': 'من تاريخ التخصيص',
  'profilecredit.todate': 'إلى تاريخ التخصيص',
  'profile.notallowed': 'لا يسمح باختيار الملف الشخصي قبل الموافقة عليه',
};
